<template>
  <div>
    <Banner heading="In-app Alerts" style="height: 120px" class="ma-0" />
    <v-container>
      <div
        v-if="!hasAlerts"
        class="d-flex justify-end mt-3"
      >
        <v-btn
          class="primary"
          @click="newNotification"
        >
          <v-icon>mdi-plus-circle-outline</v-icon>
          <span class="ml-3">Create New Alert</span>
        </v-btn>
      </div>
      <v-card class="my-3 mb-6">
        <v-card-title>
          <v-row>
            <v-col sm="6" xs="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <!-- data table -->
        <v-data-table :headers="tableHeaders"
                      :items="alerts"
                      :no-data-text="nodata"
                      :options="options"
                      :footer-props="footer"
                      :search="search"
                      :loading="isLoading"
                      @click:row="editItem"
                      class="elevation-2 primary--text">

          <template v-slot:item.startDatetime="{item}">
            <span>{{ formatDateTime(item.startDatetime) }}</span>
          </template>

          <template v-slot:item.finishDatetime="{item}">
            <span>{{ formatDateTime(item.finishDatetime) }}</span>
          </template>

          <template v-slot:item.title="{item}">
            <div>
              <v-tooltip bottom color="#121212">
                <template v-slot:activator="{ on }">
                  <span v-on="on" style="text-decoration: underline">{{item.title}}</span>
                </template>
                <div>
                  <h4>Message body:</h4>
                  <span>{{ item.body }}</span>
                </div>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog
      v-if="showEditDialog"
      v-model="showEditDialog"
      fullscreen
      persistent
    >
      <UpdateAppAlertDialog
        v-model="selectedItem"
        @close="closeEditDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
  import {Banner} from '@nswdoe/doe-ui-core';
  import UpdateAppAlertDialog from '@/components/UpdateAppAlertDialog';
  import {dateTime} from '@/utils/date';

  export default {
    name: 'app-alerts',
    components: {
      Banner,
      UpdateAppAlertDialog
    },
    data() {
      const tableHeaders = [
        { text: 'Id', value: 'id', align: 'start' },
        { text: 'Title', value: 'title', align: 'start' },
        { text: 'Start', value: 'startDatetime', align: 'start' },
        { text: 'End', value: 'finishDatetime', align: 'start' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'end' },
      ];
      return {
        tableHeaders,
        options: {
          itemsPerPage: 10,
          sortBy: ['id'],
          sortDesc: [true],
          multiSort: false,
          mustSort: true
        },
        footer: {
          itemsPerPageOptions: [5, 10, 20, -1],
          showFirstLastPage: true,
          showCurrentPage: true,
          itemsPerPageAllText: "All",
        },
        isLoading: false,
        nodata: 'No data found!',
        search: '',
        selectedItem: null,
        showEditDialog: false
      };
    },
    computed: {
      alerts() {
        return this.$store.getters.inAppAlerts('StaffPortalApp');
      },
      hasAlerts() {
        return this.alerts && this.alerts.length > 0
      }
    },
    created() {
      if (this.alerts.length === 0) {
        this.isLoading = true;
        this.$store.dispatch('fetchInAppAlerts', 'StaffPortalApp')
          .catch(error => {
            this.$log.error(error);
            this.isLoading = false;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    methods: {
      formatDateTime(d) {
        return dateTime(d);
      },
      editItem(item) {
        // make a copy of the selected item
        this.selectedItem = Object.assign({}, item);
        this.showEditDialog = true;
      },
      newNotification() {
        this.selectedItem = null;
        this.showEditDialog = true;
      },
      closeEditDialog() {
        this.selectedItem = null;
        this.showEditDialog = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-icon {
    color: $ads-navy;
  }
</style>
